import Api from './Api'
import {
  ProductSubmissionApprovePayload,
  ProductSubmissionMethod,
  ProductSubmissionType,
} from 'interfaces/ProductSubmissionInterface'

class ProductSubmission extends Api {
  readonly urls = {
    create: '/ProductSubmission/CreateSubmission',
    mine: '/ProductSubmission/GetMySubmissions',
    myDetail: '/ProductSubmission/GetMySubmissionDetail',
    approveMine: '/ProductSubmission/ApproveMySubmission',
    cancelMine: '/ProductSubmission/CancelMySubmission',
    all: '/ProductSubmission/GetAllSubmissions',
    detail: '/ProductSubmission/GetSubmissionDetail',
    approve: '/ProductSubmission/ApproveSubmission',
    reject: '/ProductSubmission/RejectSubmission',
  }

  create = async (
    type: ProductSubmissionType,
    method: ProductSubmissionMethod,
    files: File[],
  ): Promise<any> => {
    const form = new FormData()
    form.append('Type', String(type))
    form.append('Method', String(method))
    files.forEach((file) => form.append('Files', file, file.name))
    const result = await this.postMultipartData(this.urls.create, form)
    return result.data
  }

  getMine = async (
    type?: ProductSubmissionType,
    status?: number,
    top = 20,
    skip = 0,
  ): Promise<any> => {
    const params = new URLSearchParams()
    if (type) params.append('type', String(type))
    if (status !== undefined) params.append('status', String(status))
    params.append('$top', String(top))
    params.append('$skip', String(skip))
    params.append('$orderby', 'createDate desc')
    const result = await this.postJsonData(`${this.urls.mine}?${params}`)
    return result.data
  }

  getMyDetail = async (id: number): Promise<any> => {
    const result = await this.getData(`${this.urls.myDetail}/${id}`)
    return result.data
  }

  approveMine = async (data: ProductSubmissionApprovePayload): Promise<any> => {
    const result = await this.postJsonData(this.urls.approveMine, data)
    return result.data
  }

  cancelMine = async (submissionID: number): Promise<any> => {
    const result = await this.postJsonData(this.urls.cancelMine, {
      submissionID,
    })
    return result.data
  }

  getAll = async (
    type?: ProductSubmissionType,
    status?: number,
    pharmacyId?: number,
    top = 20,
    skip = 0,
  ): Promise<any> => {
    const params = new URLSearchParams()
    if (type) params.append('type', String(type))
    if (status !== undefined) params.append('status', String(status))
    if (pharmacyId) params.append('pharmacyId', String(pharmacyId))
    params.append('$top', String(top))
    params.append('$skip', String(skip))
    params.append('$orderby', 'createDate desc')
    const result = await this.postJsonData(`${this.urls.all}?${params}`)
    return result.data
  }

  getDetail = async (id: number): Promise<any> => {
    const result = await this.getData(`${this.urls.detail}/${id}`)
    return result.data
  }

  approve = async (data: ProductSubmissionApprovePayload): Promise<any> => {
    const result = await this.postJsonData(this.urls.approve, data)
    return result.data
  }

  reject = async (submissionID: number, reason: string): Promise<any> => {
    const result = await this.postJsonData(this.urls.reject, {
      submissionID,
      reason,
    })
    return result.data
  }
}

export default ProductSubmission
